import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const translations = {
  fr: {
    // Navigation
    home: 'Accueil',
    products: 'Produits',
    delivery: 'Livraison',
    about: 'À propos',
    contact: 'Contact',
    cart: 'Panier',
    
    // Hero
    heroTitle: 'Le goût authentique africain près de chez vous',
    heroSubtitle: 'Découvrez notre sélection de produits africains de qualité, livrés partout en Belgique',
    shopNow: 'Commander',
    contactUs: 'Nous contacter',
    
    // Products
    allProducts: 'Tous les produits',
    frozen: 'Surgelés',
    samosas: 'Samoussas',
    rolls: 'Rolls',
    kebabs: 'Kebabs',
    addToCart: 'Ajouter au panier',
    outOfStock: 'Rupture de stock',
    
    // Cart
    yourCart: 'Votre panier',
    emptyCart: 'Votre panier est vide',
    continueShopping: 'Continuer vos achats',
    subtotal: 'Sous-total',
    deliveryFee: 'Frais de livraison',
    total: 'Total',
    checkout: 'Passer la commande',
    remove: 'Retirer',
    
    // Checkout
    checkoutTitle: 'Finaliser la commande',
    customerInfo: 'Informations client',
    fullName: 'Nom complet',
    email: 'Email',
    phone: 'Téléphone',
    deliveryAddress: 'Adresse de livraison',
    city: 'Ville',
    postalCode: 'Code postal',
    paymentMethod: 'Méthode de paiement',
    creditCard: 'Carte bancaire (Stripe)',
    paypal: 'PayPal',
    cashOnDelivery: 'Paiement à la livraison',
    placeOrder: 'Confirmer la commande',
    processing: 'Traitement en cours...',
    
    // Delivery
    deliveryPolicy: 'Politique de livraison',
    deliveryTitle: 'Livraison partout en Belgique',
    deliveryLiege: 'Livraison à Liège',
    deliveryPeriphery: 'Périphéries de Liège',
    deliveryOutside: 'Hors Liège',
    minimumOrder: 'Commande minimum de 75€',
    
    // About
    aboutTitle: 'Qui sommes-nous ?',
    aboutWelcome: 'Bienvenue chez AfriOne BD, votre solution simple et rapide pour accéder à l\'alimentation africaine en Belgique',
    ourMission: 'Notre mission',
    missionText: 'Rendre les produits africains accessibles à tous, avec des prix très compétitifs, une excellente qualité et une livraison rapide partout en Belgique.',
    ourObservation: 'Notre constat',
    ourSolution: 'Notre solution',
    ourGoal: 'Notre objectif',
    ourCommitment: 'Notre engagement',
    ourPromise: 'Notre promesse',
    
    // Contact
    contactTitle: 'Contactez-nous',
    contactSubtitle: 'Nous sommes à votre écoute',
    sendMessage: 'Envoyer',
    yourMessage: 'Votre message',
    address: 'Adresse',
    callUs: 'Appelez-nous',
    messageSent: 'Message envoyé avec succès !',
    
    // Success/Cancel
    orderSuccess: 'Commande confirmée !',
    orderSuccessMessage: 'Merci pour votre commande. Vous recevrez un email de confirmation.',
    orderCancelled: 'Commande annulée',
    orderCancelledMessage: 'Votre commande a été annulée. Votre panier est toujours disponible.',
    backToHome: 'Retour à l\'accueil',
    
    // Footer
    followUs: 'Suivez-nous',
    quickLinks: 'Liens rapides',
    contactInfo: 'Contact',
    rights: 'Tous droits réservés',
    
    // Misc
    added: 'Ajouté au panier',
    loading: 'Chargement...',

    // Consentement
    cookiesTitre: 'Votre vie privée',
    cookiesTexte: "Ce site mesure sa fréquentation sans cookie ni traceur : rien n'est enregistré sur votre appareil et aucune adresse IP n'est conservée. Deux réglages facultatifs demandent votre accord.",
    cookiesToutAccepter: 'Tout accepter',
    cookiesToutRefuser: 'Tout refuser',
    cookiesPersonnaliser: 'Personnaliser',
    cookiesEnregistrer: 'Enregistrer mes choix',
    cookiesNecessaireTitre: 'Nécessaire au fonctionnement',
    cookiesNecessaireTexte: "Votre panier, la langue choisie et la sécurité du site. Indispensables : le site ne fonctionnerait pas sans eux, et ils ne permettent pas de vous identifier.",
    cookiesNecessaireEtat: 'Toujours actif',
    cookiesMesureTitre: 'Mesure affinée',
    cookiesMesureTexte: "Retenir d'où vous venez pendant votre visite, pour ne pas compter deux fois votre passage et savoir quelle page vous a amené jusqu'ici. Reste sur votre appareil, n'est jamais partagé.",
    cookiesPubliciteTitre: 'Publicité',
    cookiesPubliciteTexte: "Meta et Google déposent un cookie pour mesurer l'efficacité de nos annonces. Ces données sont transmises à ces sociétés.",
    cookiesEnSavoirPlus: 'Politique de confidentialité',
    cookiesGerer: 'Gérer mes cookies',
    cookiesRetour: 'Retour',
  },
  en: {
    // Navigation
    home: 'Home',
    products: 'Products',
    delivery: 'Delivery',
    about: 'About',
    contact: 'Contact',
    cart: 'Cart',
    
    // Hero
    heroTitle: 'Authentic African taste near you',
    heroSubtitle: 'Discover our selection of quality African products, delivered throughout Belgium',
    shopNow: 'Shop Now',
    contactUs: 'Contact Us',
    
    // Products
    allProducts: 'All Products',
    frozen: 'Frozen',
    samosas: 'Samosas',
    rolls: 'Rolls',
    kebabs: 'Kebabs',
    addToCart: 'Add to cart',
    outOfStock: 'Out of stock',
    
    // Cart
    yourCart: 'Your Cart',
    emptyCart: 'Your cart is empty',
    continueShopping: 'Continue shopping',
    subtotal: 'Subtotal',
    deliveryFee: 'Delivery fee',
    total: 'Total',
    checkout: 'Checkout',
    remove: 'Remove',
    
    // Checkout
    checkoutTitle: 'Complete your order',
    customerInfo: 'Customer Information',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    deliveryAddress: 'Delivery Address',
    city: 'City',
    postalCode: 'Postal Code',
    paymentMethod: 'Payment Method',
    creditCard: 'Credit Card (Stripe)',
    paypal: 'PayPal',
    cashOnDelivery: 'Cash on Delivery',
    placeOrder: 'Place Order',
    processing: 'Processing...',
    
    // Delivery
    deliveryPolicy: 'Delivery Policy',
    deliveryTitle: 'Delivery throughout Belgium',
    deliveryLiege: 'Delivery in Liège',
    deliveryPeriphery: 'Liège periphery',
    deliveryOutside: 'Outside Liège',
    minimumOrder: 'Minimum order of 75€',
    
    // About
    aboutTitle: 'Who are we?',
    aboutWelcome: 'Welcome to AfriOne BD, your simple and fast solution for accessing African food in Belgium',
    ourMission: 'Our Mission',
    missionText: 'Making African products accessible to everyone, with very competitive prices, excellent quality and fast delivery throughout Belgium.',
    ourObservation: 'Our Observation',
    ourSolution: 'Our Solution',
    ourGoal: 'Our Goal',
    ourCommitment: 'Our Commitment',
    ourPromise: 'Our Promise',
    
    // Contact
    contactTitle: 'Contact Us',
    contactSubtitle: 'We are here to help',
    sendMessage: 'Send',
    yourMessage: 'Your message',
    address: 'Address',
    callUs: 'Call Us',
    messageSent: 'Message sent successfully!',
    
    // Success/Cancel
    orderSuccess: 'Order Confirmed!',
    orderSuccessMessage: 'Thank you for your order. You will receive a confirmation email.',
    orderCancelled: 'Order Cancelled',
    orderCancelledMessage: 'Your order has been cancelled. Your cart is still available.',
    backToHome: 'Back to Home',
    
    // Footer
    followUs: 'Follow Us',
    quickLinks: 'Quick Links',
    contactInfo: 'Contact',
    rights: 'All rights reserved',
    
    // Misc
    added: 'Added to cart',
    loading: 'Loading...',

    // Consent
    cookiesTitre: 'Your privacy',
    cookiesTexte: 'This site measures its traffic without cookies or trackers: nothing is stored on your device and no IP address is kept. Two optional settings need your agreement.',
    cookiesToutAccepter: 'Accept all',
    cookiesToutRefuser: 'Reject all',
    cookiesPersonnaliser: 'Customise',
    cookiesEnregistrer: 'Save my choices',
    cookiesNecessaireTitre: 'Necessary to function',
    cookiesNecessaireTexte: 'Your basket, your chosen language and site security. Essential: the site would not work without them, and they cannot identify you.',
    cookiesNecessaireEtat: 'Always on',
    cookiesMesureTitre: 'Refined measurement',
    cookiesMesureTexte: 'Remembering where you came from during your visit, so your arrival is not counted twice and we know which page brought you here. Stays on your device, never shared.',
    cookiesPubliciteTitre: 'Advertising',
    cookiesPubliciteTexte: 'Meta and Google set a cookie to measure how well our ads perform. That data is sent to those companies.',
    cookiesEnSavoirPlus: 'Privacy policy',
    cookiesGerer: 'Manage my cookies',
    cookiesRetour: 'Back',
  }
};

const LanguageContext = createContext();

const CLE_STOCKAGE = 'afrione_langue';

// Langue de départ : le choix déjà fait par le visiteur, sinon celle de son
// navigateur, sinon le français. Sans cela, un anglophone repassait en
// français à chaque rechargement et son choix ne servait à rien.
function langueInitiale() {
  try {
    const memorisee = window.localStorage.getItem(CLE_STOCKAGE);
    if (memorisee === 'fr' || memorisee === 'en') return memorisee;
  } catch (e) {
    // Navigation privée ou stockage bloqué : on continue sans mémoire.
  }
  const navigateur = (window.navigator.language || '').toLowerCase();
  return navigateur.startsWith('en') ? 'en' : 'fr';
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(langueInitiale);

  // L'attribut lang de la page suit la langue affichée : les lecteurs d'écran
  // s'en servent pour choisir leur prononciation, et les moteurs pour indexer.
  useEffect(() => {
    document.documentElement.lang = language === 'en' ? 'en' : 'fr';
    try {
      window.localStorage.setItem(CLE_STOCKAGE, language);
    } catch (e) {
      // Stockage indisponible : le choix vaut pour la visite en cours.
    }
  }, [language]);

  const t = useCallback((key) => {
    return translations[language][key] || key;
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  }, []);

  const getLocalizedField = useCallback((item, field) => {
    const langField = `${field}_${language}`;
    return item[langField] || item[field] || '';
  }, [language]);
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, getLocalizedField }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
